module.exports = __webpack_public_path__ + "static/img/054.e4c5b63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/054.png
// module id = Xx1D
// module chunks = 0